import React, { useState, useEffect } from "react";
import './AdvServiceBranchSection.css'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { serviceBranchDetails, serviceDepartmentWise } from "../../api/api"
import { MapPin, Navigation, ChevronLeft, ChevronRight } from "lucide-react";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import pages 


// final part 
import { getUserData, getUserMobile } from "../../utils/auth";
import { useCart } from "../../Contexts/Cart.contexts"
import DateTimeStep from "./AllStepAdvanceServiceBooking/DateTimeStep";
import AdvBasicInfoStep from "./AllStepAdvanceServiceBooking/AdvBasicInfoStep";
import AdvStepTracker from "./AllStepAdvanceServiceBooking/AdvStepTracker";
import SelectTestsStep from "./AllStepAdvanceServiceBooking/SelectTestStep";
import toast from "react-hot-toast";



const AdvServiceBranchSection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { deptData } = useParams();
  const [allBranchDetails, setAllBranchDetails] = useState([]);
  const [message, setMessage] = useState("");
  const [seletedBranchIds, setSeletedBranchIds] = useState([]);
  const [DeptID, setDeptId] = useState(null);
  const [departmentWiseServices, setDepartmentWiseServices] = useState([]);
  // for service timing 
  // store full JSON objects of selected services
  const [selectedServicesData, setSelectedServicesData] = useState([]);
  console.log("deptData from paramiter =======>", deptData);
  // save seletedbranchIds from dept data 

  // for steper 
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedTests, setSelectedTests] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  // new for servicetiming and timeslots 
  const [AllServiceTiming, setAllServiceTiming] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);

  // coping the profile form same functionality  final part 
  const isLoggedin = Boolean(getUserData());
  const { cartItems, clearCart, cartFlow, setCartFlow } = useCart();
  const mobileNo = getUserMobile();
  const [activeStep, setActiveStep] = useState(0);
  const [formValid, setFormValid] = useState(true);
  const [patientType, setPatientType] = useState("new");
  const [loading, setLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [sucess, setSuccess] = React.useState(false);
  const [bookingDetails, setBookingDetails] = useState({});

  const [isOtpVerified, setIsOtpverified] = useState(false);

  const [showPatientType, setShowPatientType] = useState(isLoggedin);
  const [selectedPatient, setSelectedPatient] = useState("");
  const [showVerification, setShowVerification] = useState(!isLoggedin);
  const [profileData, setProfileData] = useState([]);
  const [allFieldsTouched, setAllFieldsTouched] = useState(false);
  // choose doctor
  const [chooseDoctor, setChooseDoctor] = useState([]);
  // 

  const [currentLocation, setCurrentLocation] = useState({
    lat: 22.5754,
    lng: 88.4791,
    selected: false,
  });
  const [formData, setFormData] = useState({
    user_id: "",
    mobile_no: isLoggedin ? mobileNo : "",
    Alt_mobile_no: "",
    PFirstName: "",
    PLastName: "",
    email: "",
    dateofbirth: "",
    PSex: "M",
    address: "",
    City: "",
    landmark: "",
    State: "West Bengal",
    Zipcode: "",
    preferredDate: "",
    preferredTime: "",
    Rtime: "",
    APPToTime: "",
    prescription: "",
    latitude: "",
    longitude: "",
    ref_doctorID: "",
    ref_doctor: "",
    regNo: '',
    specialization: '',
  });

  const goToProfileForm = () => setCurrentStep(2);

  const handleNext = () => {
    // If current step is invalid, show all validation errors
    if (!formValid) {
      setAllFieldsTouched(true);
      toast.error("Please fill all required fields");
      return;
    }
    // Reset allFieldsTouched for next step
    setAllFieldsTouched(false);
    setActiveStep((prev) => prev + 1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  // 


  useEffect(() => {
    if (deptData) {
      try {
        // Parse the JSON string from URL parameter
        const parsedData = JSON.parse(decodeURIComponent(deptData));
        console.log("Parsed deptData =======>", parsedData);
        setDeptId(parsedData.DeptID)


        if (parsedData?.BranchIds) {
          const idsArray = parsedData.BranchIds
            .replace(/[()]/g, "")   // remove ( )
            .split(",")             // split by comma
            .map(id => Number(id.trim())); // convert to number
          setSeletedBranchIds(idsArray);
          // console.log("Selected Branch IDs =======>", idsArray);
        }
      } catch (error) {
        console.error("Error parsing deptData:", error);
      }
    }
  }, [deptData]);


  // call api 
  useEffect(() => {
    serviceBranchList();
  }, []);

  const serviceBranchList = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      DType: "BR",
      RBBranch: "Y"
    }
    try {
      setLoading(true);
      const res = await serviceBranchDetails(payload);
      if (res?.data?.status === "success") {
        const apiData = res?.data?.data || [];
        if (apiData.length > 0) {
          setAllBranchDetails(apiData);
          console.log("AllBranchDetails response ====>", apiData);
          setMessage("");
        } else {
          setAllBranchDetails([]);
          setMessage("No data found");
        }
      } else {
        setMessage("Problem on API");
        setAllBranchDetails([]);
      }
    } catch (error) {
      // console.error("Error fetching service Dept:", error);
      setMessage("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // complete call api 
  console.log("allBranchDetails====>", allBranchDetails);
  // console.log("deptData from paramiter =======>", deptData);
  console.log("seletedBranchIds====>", seletedBranchIds);
  console.log("DeptID====>", DeptID);

  // call service api
  useEffect(() => {
    if (DeptID) {
      allServiceDepartmentWise()
    }
  }, [DeptID])

  const allServiceDepartmentWise = async () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      OnlyService: "Y",
      DeptId: DeptID
    }
    console.log("serviceDepartmentWise payload====>", payload);

    try {
      setLoading(true);
      const res = await serviceDepartmentWise(payload);
      if (res?.data?.status === "success") {
        const apiData = res?.data?.data || [];
        if (apiData.length > 0) {
          setDepartmentWiseServices(apiData);
          console.log("setDepartmentWiseServices response ====>", apiData);
          setMessage("");
        } else {
          setDepartmentWiseServices([]);
          setMessage("No data found");
        }
      } else {
        setMessage("Problem on API");
        setDepartmentWiseServices([]);
      }
    } catch (error) {
      // console.error("Error fetching service Dept:", error);
      setMessage("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  console.log("departmentWiseServices========>response", departmentWiseServices);
  // complete call service api 
  // selected branch list which are from dept like (usg,x-ray)
  const seletedBranchList = allBranchDetails.filter(
    branch =>
      seletedBranchIds.includes(
        branch.BranchID
      )

  )
  console.log("seletedBranchList====>", seletedBranchList);
  // selected test services 
  // NEW: Update selectedServicesData whenever selectedTests changes
  useEffect(() => {
    const servicesData = departmentWiseServices.filter(
      service => selectedTests.includes(service.service_id)
    );
    setSelectedServicesData(servicesData);
    console.log("Selected Services Full Data ====>", servicesData);
  }, [selectedTests, departmentWiseServices]);

  console.log("selectedServicesData===========> in advserviceBranch", selectedServicesData);

  // for steper 
  const handleTestToggle = (serviceId) => {
    setSelectedTests(prev =>
      prev.includes(serviceId)
        ? prev.filter(id => id !== serviceId)
        : [...prev, serviceId]
    );
  };

  const handleConfirm = () => {
    const bookingData = {
      selectedTests,
      selectedDate,
      selectedTime,
      formData,
      selectedServices: departmentWiseServices.filter(s => selectedTests.includes(s.service_id))
    };
    console.log('Booking Confirmed:', bookingData);
    alert('Booking Confirmed! Check console for details.');
  };
  //   
  console.log("selectedTests============> in branchsection", selectedTests);

  // -------------Booking api--------------








  console.log("formData===> branch section ", formData);

  const finalApi = () => {
    const payload = {
      RBAuthKey: "RBDWAh!Q1s74e",
      channel: "A",
      PCode: formData.user_id,
      // Advdate: ,
      PTitle: "Mr.",
      FName: "test",
      LName: "test",
      Gender: "M",
      dateofbirth: "01-02-1980",
      email: "test@testmail.com",
      alt_mobile_no: "1234567888",
      mobile_no: "1234567888",
      address: "xccbcbb",
      zipCode: "700001",
      landmark: "kolkata",
      city: "kolkata",
      state: "wb",
      BillDate: "10-05-2018",
      ref_doctor: "doctorname",
      ref_DoctorID: "0",
      services_list: "623",
      specimen_list: "0",
      total_price: "1500.00",
      Centerid: "1",
      userid: "1",
      BranchId: "1",
      Billremarks: "",
      ServiceData: [
        {
          testid: 623,
          AppDate: "18-12-2025",
          AppFromTime: "3:00 PM",
          AppToTime: "4:00PM",
          ServTimingID: "5"
        }
      ]
    }
    try {
      setLoading(true)


    }
    catch (err) {
      console.err(err);
    }
    finally {
      setLoading()
    }

  }


  console.log("selectedDate====> in branch section ",selectedDate);
  console.log("selected time ====> in branch section",selectedTime);
  
  




  return (

    <>
      <div className="booking-stepper-container">
        <AdvStepTracker currentStep={currentStep} />

        <div className="stepper-content">
          {currentStep === 0 && (
            <SelectTestsStep
              services={departmentWiseServices}
              selectedTests={selectedTests}
              onTestToggle={handleTestToggle}
              onNext={() => {
                console.log('Selected Tests: in branch section ', selectedTests);
                setCurrentStep(1)
              }}
            />
          )}
          {currentStep === 1 && (
            <DateTimeStep
              selectedDate={selectedDate}
              selectedTime={selectedTime}
              onDateChange={setSelectedDate}
              seletedBranchList={seletedBranchList}
              deptId={DeptID}
              departmentWiseServices={departmentWiseServices}
              selectedServicesData={selectedServicesData}
              // ADD THESE PROPS
              AllServiceTiming={AllServiceTiming}
              setAllServiceTiming={setAllServiceTiming}
              timeSlots={timeSlots}
              setTimeSlots={setTimeSlots}
              // END NEW PROPS
              // share for choose doctor
              chooseDoctor={chooseDoctor}
              setChooseDoctor={setChooseDoctor}
              onTimeChange={setSelectedTime}
              onNext={() => setCurrentStep(2)}
              onBack={() => setCurrentStep(0)}
            />
          )}
          {/* adv basic info  */}
          {currentStep === 2 && (
            <AdvBasicInfoStep
              // Form Data Management
              formData={formData}
              setFormData={setFormData}
              setFormValid={setFormValid}
              handleChange={handleChange}
              allFieldsTouched={allFieldsTouched}
              setAllFieldsTouched={setAllFieldsTouched}

              // Patient Selection
              patientType={patientType}
              setPatientType={setPatientType}
              selectedPatient={selectedPatient}
              setSelectedPatient={setSelectedPatient}

              // OTP/Verification
              showVerification={showVerification}
              setShowVerification={setShowVerification}
              showOtp={showOtp}
              setShowOtp={setShowOtp}
              isOtpVerified={isOtpVerified}
              setIsOtpverified={setIsOtpverified}
              showPatientType={showPatientType}
              setShowPatientType={setShowPatientType}

              // Profile Data
              profileData={profileData}
              setProfileData={setProfileData}

              // Location (from AdvAddressStep)
              currentLocation={currentLocation}
              setCurrentLocation={setCurrentLocation}
              // share choose
              chooseDoctor={chooseDoctor}

              // Navigation
              onNext={() => setCurrentStep(3)}
              onBack={() => setCurrentStep(1)}
            />
          )}

        </div>

        <style>{`
        .booking-stepper-container {
          max-width: 900px;
          margin: 2rem auto;
          padding: 1rem;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
        }

        @media (max-width: 768px) {
          .booking-stepper-container {
            padding: 0.5rem;
          }
        }
      `}</style>
      </div>


    </>
  )
}
export default AdvServiceBranchSection;